<template>
	<div id="menu_bar_wrap" class="bg-blue">
		<div id="menu_bar" class="container bg-blue">
			<div class="row">
				<div class="col-xs-8">
					<template v-if="user"> {{_('Credits')}}
						{{user.unlimited_credits?'∞':user.credits}}
					</template>
				</div>
				<div id="logout" class="col-xs-4 align-right">
					<slot/>
					<!--					<button type="button" name="submit"-->
					<!--							@click="logout">-->
					<!--						{{_('Abmelden')}}-->
					<!--					</button>-->
				</div>
			</div>
		</div>
		<div style="position: absolute; top: -100px; height: 100px; left: 0; right: 0; background: #fff; z-index: 999;"></div>
	</div>
</template>

<script>

	import {mapState} from 'vuex'

	export default {
		name: "Navigation",
		props: {
			user: {type: Object}
		}
	}
</script>

<style scoped>

</style>
